var render, staticRenderFns
import script from "./CarouselSlide.vue?vue&type=script&lang=js&"
export * from "./CarouselSlide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CarouselSlide.vue"
export default component.exports